// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__gIiUY","buttons":"heading_buttons__tWR2G"};